import { useGetApplicationConfigurationQuery } from '../apis/apiApplication';
import { useMemo } from 'react';
import { ApplicationConfigurationResponse, DisplayEntityIdType } from '@ydistri/api-sdk';

export function useApplicationConfiguration(): ApplicationConfigurationResponse {
  const { data: applicationConfiguration } = useGetApplicationConfigurationQuery();

  return useMemo(() => {
    if (!applicationConfiguration) {
      return {
        applicationDate: null,
        lastTransactionDate: null,
        finishExecutionWithinDays: 14,
        mdbProductIdAutoIncrement: 'INT',
        mdbWarehouseIdAutoIncrement: 'INT',
        isPickAndPackEnabled: false,
        isCustomExportEnabled: false,
        displayProductId: DisplayEntityIdType.CustomerId,
        displayStoreId: DisplayEntityIdType.CustomerId,
        isSkuAvailableSupplyEnabled: false,
        isProductGroupsEnabled: false,
        isAutoGenerated1MUMinLayerEnabled: false,
        isEvaluationDeliveryEnabled: false,
      };
    } else {
      return applicationConfiguration;
    }
  }, [applicationConfiguration]);
}
